import * as React from 'react'

// Components
import Svg from './..'

const Pencil = props => (
  <Svg viewBox='0 0 12 12' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.429 0L12 2.571v1.286l-7.286 7.286L0 12l.857-4.714L8.143 0h1.286zM4.298 10.345l4.44-4.428-2.655-2.655-4.428 4.44-.595 3.239 3.238-.596zM11.143 3.5v-.571L9.07.857H8.5L6.69 2.655 9.345 5.31l1.798-1.81z'
      fill='#06A3F7'
    />
  </Svg>
)

export default Pencil
